/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function rmvfromwish(){
  let product_id = Number(this.getAttribute('product-id'));
  let wbtn_icon_path = this.querySelector('svg path');
  this.setAttribute('title','Agregar a Wishlist')
  wbtn_icon_path.setAttributeNS(null,'fill','transparent');
  wbtn_icon_path.setAttributeNS(null,'stroke','#bc0808');
  wbtn_icon_path.setAttributeNS(null,'stroke-width','2');
  removeProductFromWishlist(this,product_id);
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function addtowish(){
  let product_id = Number(this.getAttribute('product-id'));
  let wbtn_icon_path = this.querySelector('svg path');
  this.setAttribute('title','Ya Wishlist');
  wbtn_icon_path.removeAttribute('fill');
  wbtn_icon_path.removeAttribute('stroke');
  wbtn_icon_path.removeAttribute('stroke-width');
  wbtn_icon_path.setAttributeNS(null,'fill','#bc0808');
  addProductToWishlist(this,product_id);
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function addProductToWishlist(btn,product_id){
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let wl_p = JSON.parse(localStorage.getItem('wishlist') || '[]');
  let index = wl_p.indexOf(product_id);
  if( !(index > -1) && product_id > 0 ){ 
    wl_p.push(Number(product_id));
    localStorage.setItem('wishlist',JSON.stringify(wl_p)); 
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  btn.removeEventListener("click",addtowish,false);
  btn.addEventListener("click",rmvfromwish,false);

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function removeProductFromWishlist(btn,product_id){
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let wl_p = JSON.parse(localStorage.getItem('wishlist') || '[]');
  let index = wl_p.indexOf(product_id);
  if (index > -1) { wl_p.splice(index, 1); localStorage.setItem('wishlist',JSON.stringify(wl_p)); }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  btn.removeEventListener("click",rmvfromwish,false);
  btn.addEventListener("click",addtowish,false);
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function getWishlistsProducts() {
  var items = JSON.parse(localStorage.getItem('wishlist') || '[]');
  return items.map(function (item) {
    return 'id:' + item;
  }).join(' OR ');
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function createTable(tableData) {  
  let table = document.createElement('table');
  let delimiter = ","
  let tableBody = document.createElement('tbody');
  let headers = tableData.slice(0, tableData.indexOf("\n")).split(delimiter);
  let rows = tableData.slice(tableData.indexOf("\n") + 1).split("\n");
  let head = document.createElement('thead'),
  row = document.createElement('tr');
  headers.forEach((header) => {
    let cell = document.createElement('th');
    cell.appendChild(document.createTextNode(header));
    row.appendChild(cell);
  })
  head.appendChild(row);
  table.appendChild(head);
  rows.forEach(function(rowData) {
    let row = document.createElement('tr');
    let values = rowData.split(delimiter);
    values.forEach(function(cellData) {
      var cell = document.createElement('td');
      cell.appendChild(document.createTextNode(cellData));
      row.appendChild(cell);
    });
    tableBody.appendChild(row);
  });
  table.setAttribute('id','aplicaciontable')
  table.appendChild(tableBody);
  return table;
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function contact_menu_appears(header_link,menu){
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  var contact_menu = document.querySelector(header_link);
  let cmtarget = document.getElementById(menu);
  contact_menu.addEventListener("mouseenter", function(e){
    cmtarget.setAttribute("aria-hidden", false);
  });
  contact_menu.addEventListener("mouseleave", function(e){
    cmtarget.setAttribute("aria-hidden", true);
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function submenu_appears(header,child){
  let header_menus = document.querySelectorAll(header);
  var maxWidth = 0;
  header_menus.forEach( l => { let itemWidth = l.getBoundingClientRect().width; maxWidth = Math.max(maxWidth, itemWidth); });

  header_menus.forEach(header_menu => {
    header_menu.addEventListener("mouseenter",function(e){
      let href = this.querySelector('a.head.mega-menu__link.link').getAttribute('data-href');
      this.querySelector('a.head.mega-menu__link.link').setAttribute('href',href);
      let element_position = this.querySelector('svg').getBoundingClientRect();
      let hm_x = Math.round(element_position.left);
      let hm_y = Math.round(element_position.top);
      let hm_tw = Math.round(element_position.width);
      let hm_w = Math.round(maxWidth);
      let ch_m = this.querySelector(child);
      ch_m.classList.add("open");
      ch_m.style.left = hm_x+'px';
      ch_m.style.top = hm_y+'px';
      ch_m.style.width = hm_w+'px';
      ch_m.style.transform = 'translate('+hm_tw+'px,-50%)';
    });
    header_menu.addEventListener("mouseleave",function(e){
      this.querySelector(child).classList.remove("open");
      this.querySelector('a.head.mega-menu__link.link').setAttribute('href','#');
    });
  });
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function w_submenu_appears(header,child){
  let header_menus = document.querySelectorAll(header);
  header_menus.forEach(header_menu => {
    header_menu.addEventListener("mouseenter",function(e){
      let element_position = this.getBoundingClientRect();
      let hm_x = Math.round(element_position.left);
      let hm_y = Math.round(element_position.top);
      let hm_w = Math.round(element_position.width);
      let ch_m = this.querySelector(child);
      ch_m.classList.add("open");
      ch_m.style.left = hm_x+'px';
      ch_m.style.top = hm_y+'px';
      ch_m.style.width = hm_w+'px';
    });
    header_menu.addEventListener("mouseleave",function(e){
      this.querySelector(child).classList.remove("open");
    });
  });
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
(function(){
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Clean Mini Results Search
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let search_input = document.querySelector('input.search-bar__input');
  let remove_class = document.querySelector('.search-bar__input-wrapper .clean-search');
  search_input.addEventListener("keyup",function(e){
    if (search_input.value.length > 0 && !(remove_class.classList.contains('show')) ) {
      remove_class.classList.add("show");
    }else{
      if (search_input.value.length == 0 && remove_class.classList.contains('show') ) {
        remove_class.classList.remove("show");    
      }
    }
  })
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  remove_class.addEventListener("click",function(e){
    if (remove_class.classList.contains('show')) {
      search_input.value = ''; 
      remove_class.classList.remove("show");
    }
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Mega Open Product Image
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let product_img_divs = document.querySelectorAll('#shopify-section-product-template .product-gallery .product-gallery__carousel-wrapper');
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if( product_img_divs != null ){
    product_img_divs.forEach((product_img_div) =>{
      product_img_div.addEventListener("click",function(e){
        let img_div = this;
        let product_img = this.querySelector('.product-gallery__carousel-item.is-selected img.product-gallery__image');
        if ( this.classList.contains('gf-zoom')){
          img_div.style.removeProperty('background-image');
          this.classList.remove("gf-zoom");
        }else{
          let zoom_img = product_img.getAttribute('data-zoom');
          img_div.style['background-image'] = `url('${zoom_img}')`;
          this.classList.add("gf-zoom");
        }
      });
    });
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Feed Wishlist Page
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////  
  let template = 'wishlist-products',
  wl_p = document.querySelector('#wishList-page');
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (wl_p != null) { 
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    let wishlist_items = getWishlistsProducts();
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    let wishlist_url = window.routes.searchUrl + '?view=' + template + '&type=product&q=' + wishlist_items;
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    fetch(wishlist_url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      response.text().then(function (content) {
        wl_p.innerHTML = content;
      });
    });
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // check product on wishlist
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let wlp = JSON.parse(localStorage.getItem('wishlist') || '[]');
  let btns = document.querySelectorAll('.wishlist-add-btn');
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  btns.forEach((btn) => {
    let product_id = Number(btn.getAttribute('product-id'));
    let wbtn = document.createElement('a')
    let wbtn_icon = document.createElementNS("http://www.w3.org/2000/svg",'svg');
    let wbtn_icon_path = document.createElementNS("http://www.w3.org/2000/svg",'path');
    wbtn.setAttribute('href','#');
    wbtn.setAttribute('product-id',product_id);
    wbtn_icon.classList.add('icon');
    wbtn_icon.setAttributeNS(null,'viewBox','0 0 17 15');
    wbtn_icon.setAttributeNS(null,'role','presentation');
    wbtn_icon_path.setAttributeNS(null,'d','M15.0349331 1.40485867C14.1287273.49933787 12.9252477 0 11.6443673 0S9.16000731.49933787 8.25448651 1.40417371c-.01164437.01164436-.02328874.02328873-.03493311.03561806-.01164436-.01232933-.02260377-.02328873-.03424813-.0349331C7.2790995.49933787 6.07561989 0 4.79473949 0 3.51385908 0 2.31037947.49933787 1.40417371 1.40485867.49796794 2.31037947 0 3.51385908 0 4.79473949 0 6.07561989.4986529 7.2790995 1.40417371 8.1846203L8.2195534 15l6.8153797-6.8153797c.9055208-.9055208 1.4041737-2.10900041 1.4041737-3.38988081 0-1.28019545-.4986529-2.48436002-1.4041737-3.38988082z');
    let index = wlp.indexOf(product_id);
    if((index > -1)){
      wbtn.classList.add('added');
      wbtn.setAttribute('title','Ya Wishlist')
      wbtn_icon_path.setAttributeNS(null,'fill','#bc0808');
    }else{
      wbtn.classList.add('to-add');
      wbtn.setAttribute('title','Agregar a Wishlist')
      wbtn_icon_path.setAttributeNS(null,'fill','transparent');
      wbtn_icon_path.setAttributeNS(null,'stroke','#bc0808');
      wbtn_icon_path.setAttributeNS(null,'stroke-width','2');;
    }
    wbtn_icon.appendChild(wbtn_icon_path);
    wbtn.appendChild(wbtn_icon);
    btn.appendChild(wbtn);
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let toadds = document.querySelectorAll('.to-add');
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let addeds = document.querySelectorAll('.added');
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  toadds.forEach((toadd) => {
    toadd.addEventListener("click",addtowish,false)
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  addeds.forEach((added) => {
    added.addEventListener("click",rmvfromwish,false);
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////  
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
})();
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function faplication_btn(btn){
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let aplication_btn = document.querySelector(btn);
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if( aplication_btn != null ){    
    aplication_btn.addEventListener("click",function(e){
      if (this.hasAttribute('get-aplicacion')){    
        let destiny = document.querySelector("#shopify-product-aplicacion"),
        csv = destiny.getAttribute('data-file');
        fetch(csv).then(response => response.text())
        .then(function(data){
          let aplicacion_tabla = createTable(data);
          destiny.appendChild(aplicacion_tabla);
          document.querySelector('button.card__collapsible-button[get-aplicacion]').removeAttribute('get-aplicacion');
        })
        .catch(err => console.log(err))
      }
    });
  }
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// contact_menu
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
contact_menu_appears('.header__action-item-content.contact-menu','dropdown-contact-menu');
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// submenu_nav
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
submenu_appears('span.mega-menu__title.heading',"ul.sub-mega-menu__linklist.mega-menu__linklist");
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// submenu_contact_nav
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
w_submenu_appears('span.nav-dropdown__link.sub-heading',"ul.mega-menu__linklist");
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
faplication_btn('button.card__collapsible-button[get-aplicacion]');
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
